<mat-card-header class="flex align-items-center">
  <shared-title>Cambiar logo</shared-title>
</mat-card-header>

<form>
  <mat-dialog-content>
    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <div class="w-full gap-2 flex justify-content-evenly mb-3">
        <shared-button
          [icon]="'folder_open'"
          type="button"
          [color]="'accent'"
          [typeBtn]="'button'"
          mat-raised-button
          (click)="fileInput.click()">
          Seleccionar logo*
        </shared-button>
        <input
          hidden
          (change)="onFileSelected($event)"
          #fileInput
          type="file" />
      </div>
      <div class="w-full flex justify-content-center">
        @if (isImageSaved) {
          <img [src]="imgBase64()" class="w-3" />
        } @else {
          <img src="../../../../../assets/img/placeholder.svg" class="w-3" />
        }
        <span style="color: red">{{ imageError }}</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
    <shared-button
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'">
      Cancelar
    </shared-button>

    <shared-button [icon]="'save_alt'" (click)="onSubmit()" [color]="'accent'">
      Guardar
    </shared-button>
  </mat-dialog-actions>
</form>
